import type { Pages } from "~/@types/pages"

export default (page: Pages) => {
  return page
}
